import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font, media } from '../theme/base/mixins';
import { StyledDivComponent, StyledSpanComponent } from '../types';
import { Icon } from './Icon';

interface PillProps {
  disabled?: boolean;
}

type PillPropsThemed = ThemeProps<Theme> & PillProps;

export const Pill: StyledSpanComponent<PillProps> = styled.span`
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.white};
  background: ${(props: PillPropsThemed) =>
    props.disabled
      ? props.theme.colors.grayMedium
      : props.theme.colors.secondary};
  border-radius: 100px;
  min-height: 32px;
  padding: ${(props: PillPropsThemed) =>
    props.disabled ? '7px 11px' : '7px 30px 7px 11px'};
  position: relative;
  display: inline-block;
  line-height: 1.25;

  .close {
    cursor: pointer;
    background: transparent;
    margin: 0;
    padding: 0;
    border: 0;
    position: absolute;
    top: 50%;
    right: 11px;
    transform: translateY(-50%);
  }

  ${Icon} {
    width: 14px;
    height: 14px;
    margin: 0 0 0 5px;
    overflow: hidden;
  }

  svg {
    fill: ${(props: ThemeProps<Theme>) => props.theme.colors.white};
    transition: width 0.3s;
  }
`;

export const PillCloud: StyledDivComponent = styled.div`
  margin-bottom: -8px;

  ${font(1.6, 1.8, '500')};

  .title {
    display: inline-block;
    margin: 0 30px 0 0;
    font-weight: bold;
    text-transform: uppercase;
    color: ${(props: ThemeProps<Theme>) => props.theme.colors.grayDark};
  }

  ${media.large`
    display: inline-block;
    overflow-x: hidden
  `}

  ${Pill} {
    margin: 0 8px 8px 0;
  }
`;

export const NoParams: StyledSpanComponent = styled.span`
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.grayDark};
  font-weight: 300;
`;
